import '/src/common/js/onLoad';
import '/src/components/lang/lang';
import '/src/components/burger-menu/burger-menu';
import '/src/components/location-menu/location-menu';
import '/src/views/booking/booking';
